import * as React from 'react';
import { useQuery } from 'react-apollo';

import { GET_DRIVERS, GET_FIRMWARE } from 'main/graphql';
import { LoadingSpinner, SEO } from 'main/components';
import { FirmwareList } from 'main/components/FirmwareList';

export const Downloads: React.FC = () => {
  const {
    data: driversData,
    loading: driversLoading,
    error: driversError,
  } = useQuery(GET_DRIVERS);
  const {
    loading: firmwareLoading,
    data: firmwareData,
    error: firmwareError,
  } = useQuery(GET_FIRMWARE);

  return (
    <>
      <SEO
        seoTitle="FPV Setup - Firmware Downloads & Controller Drivers - Orqa"
        seoDescription="Find the latest firmware updates and essential drivers to ensure your FPV devices are running smoothly and efficiently. Keep your hardware performing at its best"
      />
      <section className="page">
        {driversLoading || firmwareLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="wrapper wrapper--narrow  s-bottom--xlrg">
              <h1 style={{ textAlign: 'center' }}>Downloads</h1>
              <p style={{ marginBottom: '64px', marginTop: '16px' }}>
                Find the latest firmware updates and essential drivers to ensure
                your FPV devices are running smoothly and efficiently. Keep your
                hardware performing at its best
              </p>
              <h2 className="t-beta">Firmware</h2>
              <div className="s-top--xlrg">
                <>
                  {firmwareError && <p>Error...</p>}
                  {firmwareData &&
                    firmwareData.allFirmwares &&
                    firmwareData.allFirmwares.edges.length !== 0 && (
                      <FirmwareList
                        listType="firmware"
                        edges={firmwareData.allFirmwares.edges}
                      />
                    )}
                </>
              </div>
            </div>
            <div className="wrapper wrapper--narrow">
              <h2 className="t-beta">Drivers</h2>
              <div className="s-top--xlrg">
                <>
                  {driversError && <p>Error...</p>}
                  {driversData && driversData.allDriverss && (
                    <FirmwareList
                      listType="driver"
                      edges={driversData.allDriverss.edges}
                    />
                  )}
                </>
              </div>
            </div>
          </>
        )}
      </section>
    </>
  );
};
